













import Vue from "vue";

export default Vue.extend({
  name: "TableLayout",
  props: {
    title: { type: String, default: "" },
    float: { type: Boolean, default: false }, // 浮动 tools
    showTools: { type: Boolean, default: true }, // 显示隐藏 tools 开关
    loading: { type: Boolean, default: false }
  },
  data() {
    return {};
  }
});
